<div class="flex flex-col gap-3 md:gap-4" [formGroup]="formGroup">
    <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
        {{ 'request.instrument-only-deal-information' | translate }}
    </h2>
    <div class="flex flex-col gap-4 mt-4">
        <sh-select
            formControlName="productLine"
            [label]="'request.instrument-only.product-line-label' | translate"
            [mandatory]="true"
            [options]="productLineOptions"
        ></sh-select>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <sh-input-text
                formControlName="soldTo"
                [label]="'request.instrument-only.sold-to-number' | translate"
            ></sh-input-text>
            <sh-input-text
                formControlName="shipTo"
                [label]="'request.instrument-only.ship-to-number' | translate"
            ></sh-input-text>
        </div>
        <div class="flex justify-end mt-2">
            <sh-button
                [label]="'request.instrument-only.query-onedx' | translate"
                icon="search"
                icon-position="start"
                size="max-content"
                [disabled]="!canQuery() || loading()"
                (click)="queryOneDx()"
            ></sh-button>
        </div>
    </div>
    @if (loading() || rowData().length !== 0) {
        <div #resultsSection class="w-full h-px bg-shui-base-4 my-8"></div>
        <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
            {{ 'request.instrument-only.customer-information' | translate }}
        </h2>
        @if (loading()) {
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-shui-base-2 rounded-md p-6">
                @for (i of [1, 2, 3, 4]; track i) {
                    <div class="flex flex-col gap-1">
                        <div class="h-3 w-24 bg-shui-base-3 rounded animate-pulse"></div>
                        <div class="h-4 w-48 bg-shui-base-3 rounded animate-pulse mt-1"></div>
                    </div>
                }
            </div>
        } @else if (customerInformation()) {
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-shui-base-2 rounded-md p-6">
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.instrument-only.customer-name' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()!.customerName
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.instrument-only.quote-contract-number' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()!.quoteContractNumber
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.instrument-only.sold-to-address' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()!.soldToAddress
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.instrument-only.ship-to-address' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()!.shipToAddress
                    }}</span>
                </div>
            </div>
        }
        <div class="w-full h-px bg-shui-base-4 my-8"></div>
        <div class="flex justify-between items-center gap-2 mb-2">
            <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
                {{ 'request.instrument-only.material-information' | translate }}
            </h2>
            <sh-button
                [label]="'request.instrument-only.upload-file' | translate"
                icon="upload"
                icon-position="start"
                color="tertiary"
                size="max-content"
            ></sh-button>
        </div>
        @if (loading()) {
            <div class="w-full flex flex-col gap-0">
                <div class="h-10 w-full bg-shui-base-3 rounded-t animate-pulse"></div>
                @for (i of [1, 2, 3]; track i) {
                    <div class="h-12 w-full bg-shui-base-2 animate-pulse border-t border-shui-base-2"></div>
                }
            </div>
        } @else {
            <div class="w-full h-[500px]">
                <ag-grid-angular
                    [gridOptions]="gridOptions"
                    [rowData]="rowData()"
                    [columnDefs]="colDefs"
                    (cellValueChanged)="onCellValueChanged($event)"
                    class="w-full h-full"
                />
            </div>
        }
        @if (showContinue()) {
            <div class="mt-2 flex items-center justify-end">
                <sh-button
                    [label]="'common.continue' | translate"
                    [disabled]="formGroup.invalid"
                    (click)="onContinue()"
                ></sh-button>
            </div>
        }
    }
</div>
